// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Webapi__Fetch from "rescript-webapi/src/Webapi/Webapi__Fetch.bs.mjs";

function $$fetch$1(url, payload, file, method_Opt, jwt, authHeader, overrideHeadersOpt, query, param) {
  var method_ = method_Opt !== undefined ? method_Opt : /* Get */0;
  var overrideHeaders = overrideHeadersOpt !== undefined ? overrideHeadersOpt : [];
  var headers = {};
  if (authHeader !== undefined) {
    headers["Authorization"] = authHeader;
  } else if (jwt !== undefined) {
    headers["Authorization"] = "Bearer " + jwt;
  }
  var body = payload !== undefined ? (
      file !== undefined ? undefined : (headers["Content-Type"] = "application/json", headers["Accept"] = "application/json", Caml_option.some(JSON.stringify(Caml_option.valFromOption(payload))))
    ) : (
      file !== undefined ? (headers["Accept"] = "application/json", Caml_option.some(Caml_option.valFromOption(file))) : undefined
    );
  Belt_Array.forEach(overrideHeaders, (function (param) {
          headers[param[0]] = param[1];
        }));
  var credentials = jwt !== undefined ? /* Omit */0 : /* SameOrigin */1;
  return fetch(url, Webapi__Fetch.RequestInit.make(method_, Caml_option.some(headers), body, undefined, undefined, undefined, credentials, undefined, undefined, undefined, undefined, undefined)(undefined));
}

export {
  $$fetch$1 as $$fetch,
}
/* No side effect */
